export default {
  actions: 'Ações',
  action: 'Ação',
  cnes: 'CNES',
  cns: 'CNS',
  coverage: 'Abrangência',
  county: 'Município',
  cpf: 'CPF',
  email: 'E-mail',
  health_region: 'Região de saúde',
  macro: 'Macro',
  macroregion: 'Macrorregião',
  name: 'Nome',
  mother_name: 'Nome da mãe',
  permissions: 'Permissões',
  profile: 'Perfil',
  profiles: 'Perfis',
  status: 'Status',
  uf: 'UF',
  slug: 'Slug',
  unity: 'Unidade',
  type_unity: 'Tipo de unidade',
  code: 'Código',
  description: 'Descrição',
  procedure_types: 'Tipos de procedimento',
  personal_data: 'Dados pessoais',
  address: 'Endereço',
  documents: 'Documentos',
  certificate: 'Certidão',
  observations: 'Observações',
  date_of_birth: 'Data de nascimento',
  search: 'Pesquisa',
  procedure_code: 'Código procedimento',
  procedure_name: 'Nome procedimento',
  occupation_code: 'Código ocupação',
  occupation_name: 'Nome ocupação',
  title_attachment: 'Título do anexo',
  extension: 'Extensão',
  length: 'Tamanho',
  send_date: 'Data de envio',
  new_request: 'Nova solicitação',
  patient: 'Paciente',
  solicitation_date: 'Data da solicitação',
  procedure: 'Procedimento',
  occupation: 'Ocupação',
  protocol: 'Protocolo',
  binding_status: 'Status de vinculação',
  add_observation: 'Adicionar observação',
  bind_protocol: 'Vincular protocolo',
  occupation_sub_occupation: 'Ocupação/Sub-Ocupação',
  sub_occupation_name: 'Nome sub-ocupação',
  sub_occupation_code: 'Código sub-ocupação',
  council: 'Conselho',
  attachments: 'Anexos',
  type: 'Tipo',
  addresses: 'Endereços',
  outpatient: 'Ambulatorial ',
  ppp: 'Exames de Imagem',
  unities: 'Unidades',
  regulate_patient: 'Regular paciente',
  schedule_details: 'Datalhes do agendamento',
  type_procedure: 'Tipo de procedimento',
  sub_occupation: 'Sub-ocupação',
  regulated_date: 'Data da regulação',
  district: 'Distrito',
  schedule_date: 'Data da agenda',
  selected_occupation: 'Ocupação selecionada',
  procedure_group: 'Grupo de procedimento',
  complements: 'Complementos',
  modification_date: 'Data/hora da modificação',
  user: 'Usuário',
  full_name: 'Nome completo',
  procedure_code_name: 'Código/Nome procedimento',
  occupation_code_name: 'Código/Nome ocupação',
  sub_occupation_code_name: 'Código/Nome sub-ocupação',
  diagnostic_code_name: 'Código/Diagnóstico',
  unity_orderer: 'Unidade solicitante',
  check_professional: 'Verificar profissional',
  files: 'Arquivos',
  history: 'Histórico',
  procedures: 'Procedimentos',
  canceled: 'Cancelada',
  judicial_demand: 'Liminar Judicial',
  diagnostic: 'Diagnóstico',
  diagnostics: 'Diagnósticos',
  list_attachments: 'Lista de anexos',
  group: 'Grupo',
  list_procedures: 'Lista de procedimentos',
  modifiers: 'Modificadores',
  ordinance: 'Portaria',
  start_date: 'Data início',
  end_date: 'Data fim',
  value: 'Valor',
  contracted_unities: 'Unidades Contratadas',
  total_quantity_contracted: 'Qtd Total Contratada',
  total_quantity_performed: 'Qtd Total Realizada',
  group_procedures: 'Grupo de procedimentos',
  version: 'Versão',
  title: 'Título',
  protocol_details: 'Detalhes do protocolo',
  priority_classification: 'Classificação de prioridade',
  sended_attachments: 'Anexos enviados',
  clinical_resume: 'Resumo clínico',
  author: 'Autor',
  date: 'Data',
  unity_reference: 'Unidade de referência',
  solicitation_status: 'Status da solicitação',
  motive_to_reprove: 'Motivo para reprovação',
  evaluation: 'Avaliação',
  unity_bind: 'Unidade de vínculo',
  ibge_code: 'Código IBGE',
  lat: 'Latitude',
  lon: 'Longitude',
  municipality: 'Município',
  neighborhood: 'Bairro',
  adjustment_motive: 'Motivo do ajuste',
  reproment_motive: 'Motivo da reprovação',
  required: 'Obrigatório',
  integrations_and_permissions: 'Integrações e permissões',
};
